/**
 * Lokalizované obrázky (obrázky s vypáleným textem).
 *
 * Konvence: k obrázku "neco.jpg" se do Shopify → Content → Files nahraje "neco_en.jpg".
 * Tenhle skript pak v ne-německé verzi prohodí src/srcset u obrázků, jejichž název je
 * v seznamu window.bpImgI18n.names (seznam generuje scripts/update-i18n-image-list.py
 * podle toho, co je reálně nahrané ve Files — takže se nikdy nesahá na obrázek bez EN verze).
 *
 * Když se EN soubor přesto nenačte, onerror vrátí původní obrázek.
 */
(function () {
  var cfg = window.bpImgI18n;
  if (!cfg || !cfg.locale || cfg.locale === 'de' || !cfg.names || !cfg.names.length) return;

  var suffix = '_' + cfg.locale;

  // "neco.jpg" → "neco_en.jpg" (název bereme z cesty, query string zůstává)
  function localizeUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/([^/?#]+)(\?[^#]*)?$/);
    if (!m) return null;
    var file = m[1];
    var dot = file.lastIndexOf('.');
    if (dot < 1) return null;
    if (cfg.names.indexOf(file) === -1) return null;
    var localized = file.slice(0, dot) + suffix + file.slice(dot);
    return String(url).replace(file, localized);
  }

  function localizeImg(img) {
    if (img.dataset.bpI18nDone) return;
    var original = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    var newSrc = localizeUrl(original.src);
    if (!newSrc) return;
    img.dataset.bpI18nDone = '1';

    img.addEventListener('error', function onErr() {
      img.removeEventListener('error', onErr);
      if (original.srcset) img.setAttribute('srcset', original.srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', original.src);
    });

    if (original.srcset) {
      var swapped = original.srcset.split(',').map(function (part) {
        var bits = part.trim().split(/\s+/);
        bits[0] = localizeUrl(bits[0]) || bits[0];
        return bits.join(' ');
      }).join(', ');
      img.setAttribute('srcset', swapped);
    }
    img.setAttribute('src', newSrc);
  }

  function scan(root) {
    (root || document).querySelectorAll('img[src]').forEach(localizeImg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // obrázky doplněné později (sekce načtené AJAXem, konfigurátor, galerie)
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      records.forEach(function (rec) {
        rec.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') localizeImg(node);
          else if (node.querySelectorAll) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
